import { mapGetters } from 'vuex' 

export default {

  data: () => ({
    isClient: false,
    isDisabled: false,
    isLoading: false,
    client:{
      phone: null,
      name: null,
      surname: null,
      patronymic: null,
      email: null,
      checkbox: false,
      checkbox2: false,
    },
    advocate:{
      phone: null,
      name: null,
      surname: null,
      patronymic: null,
      email: null,
      isFith: false,
      isUr: false,
      experience: null,
      certificate: null,
      region_id: [],
      specialization: [],
      information: null,
      filePasport: null,
      fileCertificate: null,
      is24h: false,
      isOfert: false,
    },
    currentTime: 0,
    timer: null,
    dialog: false,
    isFileError: false,
    step: 1,
    specializations:[],
    regions: [],
  }),

  methods: {
    modal(){
      this.step = 1;
      this.dialog = !this.dialog;
    },
    closse(){
      this.client = {
        phone: null,
        name: null,
        surname: null,
        patronymic: null,
        email: null,
        checkbox: false,
        checkbox2: false,
      },
      this.advocate={
        phone: null,
        name: null,
        surname: null,
        patronymic: null,
        email: null,
        isFith: false,
        isUr: false,
        experience: null,
        certificate: null,
        region_id: null,
        specialization: null,
        information: null,
        filePasport: null,
        fileCertificate: null,
        is24h: false,
        isOfert: false,
      },
      this.dialog = !this.dialog;
    },
    setAll(event){
      if(event){
        this.advocate.region_id = [];
        this.regions.forEach(item => {
          this.advocate.region_id.push(item.id);
        });
      }else{
        this.advocate.region_id = [];
      };
    },
    setAllSpec(event){
      if(event){
        this.advocate.specialization = [];
        this.specializations.forEach(item => {
          this.advocate.specialization.push(item.id);
        });
      }else{
        this.advocate.specialization = [];
      };
    },
    changeStep(number){
      if(number == 1){
        if (this.step == 5){
          return;
        }else{
          if (!this.isClient && this.step === 4 && (!this.advocate.filePasport || !this.advocate.fileCertificate)){
            this.isFileError = true
            return
          }
          if(!this.$refs.form.validate()) return
          this.step = this.step + 1;
        }
      }
      if(number == 0){
        if (this.step == 1){
          return
        }else{
          this.step = this.step - 1;
        }
      }
    },
    
    setClient () {
      this.isDisabled = true
      this.$axios.post('auth/registration/client', 
      {
        phone: this.client.phone.replace(/[^\w\s]/gi, ''),
        name: this.client.name,
        surname: this.client.surname,
        patronymic: this.client.patronymic,
        email: this.client.email,
        checkbox: this.client.checkbox,
        checkbox2: this.client.checkbox2,
      }
      ).then(res => {
        if(res.data.cod == 200){
          this.closse();
          this.$root.$emit('modal.auth',{
            phone: this.client.phone,
          });
        }
      }).finally(() => {
        this.isDisabled = false
      });
    },

    onFileChangePasport(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.advocate.filePasport = files[0];
    },

    onFileChangeCertificate(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.advocate.fileCertificate = files[0];
    },
    
    toHelp(){
      this.$root.$emit('modal.help');
      this.closse()
    },

    nextStep(){
      if(!this.$refs.form.validate()) return
      if(this.isClient && this.step === 2){
        this.setClient()
        return
      }
      if(!this.isClient && this.step === 2 && (!this.advocate.isFith && !this.advocate.isUr)){
        return
      }
      if (!this.isClient && this.step === 4 && (!this.advocate.filePasport || !this.advocate.fileCertificate)){
        this.isFileError = true
        return
      }
      if(!this.isClient && this.step === 5){
        this.setAdvocate()
        return
      }
      this.step = this.step + 1;
    },
    setAdvocate(){
      this.isDisabled = true
      let formData = new FormData();
      for ( var key in this.advocate ) {
        formData.append(key, this.advocate[key]);
      }
      formData.append('phone', this.advocate.phone.replace(/[^\w\s]/gi, ''));

      this.$axios.post('auth/registration/adv', 
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      } 
      ).then(res => {
        if(res.data.cod == 200){
          // this.advocate.phone = temp;
          this.step = 6;
        }
      }).finally(() => {
        this.isDisabled = false
      });
    },
    getDate(){
      this.isLoading = true;
      this.$axios.get('auth/registration/atribute').then(res => {
        if(res.data.cod == 200){
          this.regions = res.data.result.region;
          this.specializations = res.data.result.specialization;
        }
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
  mounted() {
    this.getDate();
    this.$root.$on('modal.reg', (res) => {
      if(res){
        this.isClient = false;
        this.advocate.name = res.name;
        this.advocate.email = res.email;
        this.advocate.phone = res.phone;
      }
      this.modal();
    })
  },
  watch: {
    currentTime(time) {
      if (time === 0) {
        this.stopTimer();
      }
    }
  },
  computed: {
    ...mapGetters(['getApi', 'rules']),
  }
};


// WEBPACK FOOTER //
// ./src/modals/reg/reg.js